<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>Keynote Speakers</span>
      </div>
      <div class="lists">
        <div class="list" v-for="(item, index) in lists" :key="index">
          <div class="img">
            <img :src="'https://www.maiqs2026.org/index/public/images/img00' + (index + 1) + '.jpg'" alt="">
          </div>
          <div class="cons">
            <div class="list-title">
              <p>{{ item.name1 }}</p>
              <p>{{ item.name2 }}</p>
            </div>
            <div class="list-text" v-html="item.text">
            </div>
            <div class="list-speech">
              <p>Title of {{ item.sex == 1 ? 'his' : 'her' }} speech:</p>
              <p>{{ item.speech }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lists: [{
        name1: 'Professor Binrui Wang (Opening keynote)',
        name2: 'China Jiliang University',
        text: 'Prof. Binrui Wang (PhD) is a doctoral advisor, a state-sponsored returned overseas scholar, and the Vice President of China Jiliang University. He serves as the Director of the National and Local Joint Engineering Laboratory for Disaster Monitoring Technologies and Instruments, the discipline leader of the Provincial First-Class Discipline in Control Science and Engineering, and a recipient of the Zhejiang Province New Century Excellent Talent Award. His main research areas include bionic robots, quality inspection robots, and intelligent perception. As the first or corresponding author, he has published over 160 high-level academic papers, authored one monograph and two textbooks, and holds over 60 authorized invention patents as the first inventor. He has supervised over 100 graduate students and contributed to the formulation and revision of seven national standards and one ISO international standard. He has received the second prize from the Chinese Society of Automation. He serves as the Vice Chairman of the Robotics Professional Committee of the China Association for Standardization. Additionally, he is a member of the National Standards Committee Technical Committees TC591 and TC307.',
        speech: '',
        sex: 1
      }, {
        name1: 'Professor Alistair Forbes',
        name2: 'National Physical Laboratory (NPL), UK',
        sex: 1,
        text: `
            <p>Since joining the National Physical Laboratory (NPL) in 1985, Alistair Forbes has carried out research in mathematical and statistical modelling, algorithm design, uncertainty evaluation, numerical software development and validation with applications to metrology.  Much of his work has been in the area of coordinate metrology, often undertaken in European collaborative projects, including:</p>
           · Generation of test data for coordinate metrology software
           <br> · Parametrization of geometric elements
           <br> · Reference software for fitting geometric elements according to the Chebyshev criterion
           <br> · The Virtual CMM
           <br> · CMM calibration
           <br> · Traceability in computationally-intensive metrology
           <br> · Standards for the evaluation of uncertainty of coordinate measurements in industry  <a href="https://eucom-empir.eu" target="_blank">https://eucom-empir.eu</a>
            <p>He is a Fellow in the Data Science Department at NPL and a Visiting Professor at the University of Huddersfield and at the University of Strathclyde, UK, He is chair of the IMEKO Technical Committee 21, Mathematical Tools for Measurements and a member of ISO TC 213, Geometric Product Specification.</p>
          
        `,
        speech: 'Computation with dimensioned variables and machine-actionable information'
      }, {
        name1: 'Professor Fang Fang',
        name2: 'National Institute of Metrology, China',
        sex: 0,
        text: `
          Dr. Fang Fang is a Research Professor and Executive Deputy Director of the Center for Time and Frequency at the National Institute of Metrology, China (NIM). She earned her Ph.D. in Physics from Pennsylvania State University in 2007. Following a postdoctoral fellowship at Los Alamos National Laboratory, she joined NIM in 2010. Recognized as a top-tier national talent, her prestigious accolades include the First Prize of the National Science and Technology Progress Award (2016, as PI), the National Innovation and Excellence Award (2017), selection for the National Hundred, Thousand, and Ten Thousand Talents Project (2017), and the Special Government Allowance (2018).
          <br>
          Her current research primarily focuses on cold atom fountain clocks, ultra-stable microwave sources, and primary frequency standards. She has served as the principal investigator for numerous major research projects, including those funded by the National Natural Science Foundation of China (NSFC), the National Key Scientific Instrument and Equipment Development Project of the Ministry of Science and Technology, and the BeiDou-2 Navigation Satellite System Special Project. Dr. Fang has authored or co-authored over 20 papers in SCI- and EI-indexed journals. She currently leads the Fountain Clock Innovation Team at NIM.`,
        speech: 'Progress in Optical Clock Research '
      }, {
        name1: 'Professor Yong Yan ',
        name2: 'Beihang University, China',
        sex: 1,
        text: `
          Professor Yong Yan is a Fellow of the Royal Academy of Engineering (UK), an IEEE Fellow, and a Professor and PhD supervisor at Beihang University. Since July 1, 2024, he has served as the Director and Chief Scientist of the Carbon Neutrality International Research Center at the International Innovation Research Institute of Beihang University. He previously held positions at the University of Kent, UK, including Professor in the School of Engineering, Director of Research Innovation, and Director of the Measurement & Control Research Centre. Professor Yan obtained his Bachelor's, Master's, and PhD degrees from Tsinghua University (1980–1988) and Teesside University, UK (1989–1992). He was elected an IEEE Fellow in 2011 and a Fellow of the Royal Academy of Engineering in 2020. His major professional roles include Vice President of the International Measurement Confederation (IMEKO), Council Member of the International Flame Research Foundation (IFRF), Executive Council Member of the UK Fuel and Energy Society, Editor-in-Chief of Measurement: Energy, Editorial Board Member of Measurement, and Qiu Shi Visiting Professor at Zhejiang University.
        `,
        speech: 'AI-enpowered Cost-effective Industrial Process Measurement'
      }, {
        name1: 'Professor Yan-Fu Li',
        name2: 'Tsinghua University, China ',
        sex: 1,
        text: ` 
          Prof. Yan-Fu Li is currently the Director of the Institute for Quality & Reliability of Tsinghua University and a full Professor at the Department of Industrial Engineering in Tsinghua University, China. From 2011 to 2016, he was a faculty member at CentraleSupélec in Université Paris-Saclay, France. His research areas mainly include condition monitoring, fault detection, and system reliability with applications to various engineering systems.
          <br>
          Dr. Li has published over 100 peer-reviewed international journal papers with an H-index = 41. The representative papers appear in IEEE Transactions, POM, IJOC, etc. He has been continuously elected as the Highly Cited Chinese Researcher 2019-2023 by Elsevier and Top 2% Scientists Worldwide 2021-2022 by Stanford University. He is the Principal Investigator (PI) of several government projects, including the key project funded by the National Natural Science Foundation of China and the National Key R&D Program of China. He is also experienced in industrial research; the long-term partners include the top enterprises such as Huawei, China Southern Power Grid, etc. He holds 12 national patents, 1 international patent, and 1 IEEE standard. He has won multiple national society and international society search/paper awards, including the Gold Medal of the Geneva International Invention Exhibition. He is currently an Associate Editor of “IEEE Transactions on Industrial Informatics” and “Reliability Engineering & System Safety” and was an AE for “IEEE Transactions on Reliability” (2017-2024). He is the founding Chair of the IEEE Technology and Management Society Beijing Chapter.
        `,
        speech: 'Beyond Autonomy: Reliability and Resilience for Next Generation Intelligent Unmanned Systems'
      }, {
        name1: 'Professor Huijie Zhao',
        name2: 'Beihang University, China',
        sex: 0,
        text: `
          Professor Huijie Zhao is a Level 2 Lantian Professor, doctoral advisor, and academician candidate at Beihang University. She currently serves as Director of the Key Laboratory of Aerospace Broad-Spectrum Detection and Intelligent Perception under the Ministry of Industry and Information Technology (MIIT), Deputy Director of the Key Laboratory of Precision Opto-Mechatronics Technology under the Ministry of Education (MOE), and Responsible Professor for national first-class undergraduate majors and first-class undergraduate courses.
          <br>
          Professor Zhao is awarded the National March 8th Red Banner Pacesetter title, State Council Special Allowance Expert, Beijing Outstanding Postgraduate Supervisor, and Beijing Outstanding Teacher. Selected into the MOE Program for New Century Excellent Talents in 2004, and listed among the World’s Top 2% Scientists in 2025.
          <br>
          Professor Zhao is a leading scholar in vision sensing and metrology in China, and she has solved critical technical challenges in 3D vision measurement including:
          <br>
          · Parallel single-pixel imaging theory and technology: Realized decoupling of complex optical interference such as interinflection and subsurface scattering.
          · Ultra-high reflectance dynamic range surface measurement technology based on multi-step phase-shifting and multi-brightness projection: Achieved spray-free measurement of high-reflection and heterogeneous surfaces with a dynamic range up to 3000:1.
          · Phase-matching-based stitching technology: Realized marker-free stitching measurement of large-scale complex weak-texture surfaces.
          · Novel accuracy evaluation reference devices and optical coordinate measuring machines: Developed 6 group standards, solving the international challenge of lacking reference devices and evaluation standards, for 3D vision measurement.
          <br>
          Her innovative achievements have been successfully applied to multiple national key projects such as new aircraft. She has won 2 national science and technology awards and 8 provincial/ministerial science and technology awards. She has published more than 200 academic papers, authorized over 100 national invention patents, formulated 28 standards, and authored 1 academic monograph.
        `,
        speech: 'Challenges and Application of In-situ Measurement Technology for Large Complex Components'
      }, {
        name1: 'Professor Hongzhong Huang',
        name2: 'University of Electronic Science and Technology of China',
        sex: 1,
        text: `
        Prof. Hongzhong Huang is a Professor (Level II, inaugural cohort of 2007) and a Ph.D. Advisor at the University of Electronic Science and Technology of China (UESTC). At UESTC, he serves as the Director of the Committee for International Cooperation and Education, the Vice Chairman of the Science and Technology Committee, and the Director of the Research Center for System Reliability and Safety. Recognized as an outstanding scholar, his distinguished honors include the Special Government Allowance from the State Council, the National Science Fund for Distinguished Young Scholars (Category B), and the National Excellent Doctoral Dissertation Award.  He serves on the Ministry of Education's Teaching Steering Committee for Mechanical Engineering, and acts as an appointed reliability expert for the Equipment Development Department of the Central Military Commission (CMC), the Commission of Science, Technology and Industry for National Defense (COSTIND), and the Air Force. Furthermore, he is a member of the Expert Committee for Aero-engine and Gas Turbine Bearings at the Aero Engine Corporation of China (AECC) and serves as the Chief Technical Consultant for Reliability at leading industrial enterprises, including XCMG Group and TZ Group.
        `,
        speech: 'Life-Cycle Reliability Engineering of Intelligent Equipment: Data-Driven Modeling and Optimal Decision Making'
      }, {
        name1: 'Professor Abdérafi CHARKI',
        name2: 'Université d’Angers, France',
        sex: 1,
        text: `
          Abdérafi Charki, PhD, is a Professor at the University of Angers (France) in the Quality and Reliability Department of the Polytech engineering school, where he teaches industrial engineering, dependability, mechanics, metrology, and quality engineering. His research at LARIS (Laboratory of Research in Systems Engineering) focuses on the assessment of the performance and dependability of complex systems. He coordinates the DIA-SOLAIRE project, funded by the French National Research Agency, which aims to develop artificial intelligence-based tools for the diagnosis and performance forecasting of operating photovoltaic power plants.
        `,
        speech: 'Deep Learning and Uncertainty for Renewable Energy Systems Diagnostics and Forecasting'
      }, {
        name1: 'Dr QingPing Yang (Synthesis Keynote)',
        name2: 'Brunel University of London, UK',
        sex: 1,
        text: `
        Dr QingPing Yang is affiliated with Brunel University of London as a Reader and is the founder of the Brunel Quality Engineering and Smart Technology (QUEST) Research Group and the Robotics and Automation Research Group.  He joined the Brunel Centre for Manufacturing Metrology in 1988 with a visiting scholarship awarded by the AVIC and obtained his PhD in 1992 on a patented smart high-precision 3D probing system for coordinate measuring machines. His research covers sensors, instrumentation, dimensional metrology, robotics, artificial intelligence, quality engineering, and sustainability. Over the past three decades, he has developed an integrated framework for measurement, AI, and quality engineering, underpinned by fundamental principles for measurement and intelligent systems. He has published over 140 papers, supervised 27 PhD students to completion, and led research projects funded by the EU, UK government, and industry, securing over £2.7M as Principal Investigator and £1.2M as Co-Investigator.  His current work focuses on artificial intelligence and its applications through the development of AI-driven methods and systems for measurement, control, quality, and sustainability, grounded in unified principles.  Dr Yang is Editor-in-Chief of the International Journal of Metrology and Quality Engineering.
        `,
        speech: 'Unification of Measurement, Control, AI, Quality and Sustainability: Theory and Applications'
      },]
    };
  },
  methods: {
    toRegFn() {
      this.$router.push("/loginThen");
    },
    toFn() {
      window.open("https://maiqsauthor.manuscriptcloud.com", '_blank');
    },
    download(index) {
      if (index == 1) {
        let href =
          "https://www.ids2024.com/public/uploads/down/Abstract_Template_IDS2024.docx";
        var a = document.createElement("a");
        a.href = href;
        a.download = `Abstract_Template_IDS2024.docx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        let href =
          "https://www.maiqs2026.org/index/public/file/template.doc";
        var a = document.createElement("a");
        a.href = href;
        a.download = `Template_MAIQS2026.doc`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },
  },
};
</script>

<style scoped>
.font-18 {
  font-size: 20px;
}

.lists {
  max-width: 1200px;
  margin: 0 auto;
}

.list {
  display: flex;
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid #999;
}

.list-title p,
.list-speech p {
  font-size: 17px;
  font-weight: 600;
}

.list-speech p {
  font-size: 14px;
}

.list-text {
  margin: 5px 0;
}

.img {
  width: 200px;
  /* height: 200px; */
  flex-shrink: 0;
  margin-right: 20px;
}

.img img {
  /* width: 100%;
  height: auto; */
  width: 200px;
  height: 250px;
  object-fit: cover;
}

.icon-word {
  width: 25px;
  height: auto;
}

.text-blue {
  color: #428bca;
}

.text-gray {
  color: #7f7f7f;
}

.curdis {
  cursor: no-drop;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 140px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}


@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .text-red {
    color: rgb(181, 53, 53);
  }

  .sub-img {
    position: relative;
    left: 0;
    top: 0px;
    float: right;
    width: 60px;
    height: auto;
    margin-top: -25px;
  }

  .lists {
    padding: 0 10px;
    box-sizing: border-box;
  }

  .list {
    display: block;
  }

  .img {
    width: 100%;
    height: auto;
    text-align: center;
  }

  .img img {
    width: 60%;
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/speakers.vue